import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../asserts/images/logo.png';
import './Header.css';

function Header(props) {
  const [isSecondNavbarScrolled, setIsSecondNavbarScrolled] = useState(false);
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(!clicked);
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = 50;

      setIsSecondNavbarScrolled(scrollPosition > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div>
        <nav className={`navbar-top navbar fixed-top navbar-dark bg-orange ${isSecondNavbarScrolled ? 'hidden-navbar' : ''}`} style={{ width: '100%', height: '7%' }}>
          <div style={{ paddingLeft: '130px', paddingRight: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div id='ministry_logo'>
              <div className='responsiveheader'>
                <span>République Tunisienne</span> <br />
              <span> Ministère de l’Enseignement Supérieur et de la Recherche Scientifique / Université de Monastir</span>
              </div>
            </div>
            <div className='iconcontact'>
              <a className="FB" href="#">
                <i className="fa-brands fa-square-facebook"></i>  
              </a>
              <a className="LK" href="#">
                <i className="fa-brands fa-linkedin"></i>           
              </a>
              <a className="LK" href="#">
                <i className="fa-sharp fa-solid fa-envelope"></i>
              </a>
            </div>
          </div>
        </nav>
      </div>

      <div className="header-container" style={{ paddingTop: isSecondNavbarScrolled ? '42px' : '0', paddingLeft: '0px', marginTop: isSecondNavbarScrolled ? '-90px' : '0' }}>
        <nav className={`navbar ${isSecondNavbarScrolled ? 'navbar-3d' : 'navbar-transparent'}`}>
        <ul className={`navbar-nav ${isSecondNavbarScrolled ? 'scrolledToggleBar' : ''} ${clicked ? ' active' : ''}`}>
        <li className="nav-item logoitemmodile">
                <Link to="/" className="logo" href="#">
                  <img src={logo} alt="logo isimm" style={{ width: '135px', height: 'auto', marginLeft: '10px' }} />
                </Link>
              </li>
            <li className="nav-item">
              <input
                type="checkbox"
                id="isimmCheckbox"
              />
              <label htmlFor="isimmCheckbox" className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>ISIMM</label>
              <div className='bar1 bar' id='bar1'>
                <ul className='ul'>
                  <li className='li'> <Link to="/Introduction" className='linkliste' >Présentation </Link></li>
                  <li className='li'><Link to="/Organigramme" className='linkliste' >Organigramme</Link></li>
                  <li className='li'><Link to="/Enseignant" className='linkliste' >Enseignant</Link></li>
                  <li className='li'><Link to="/Administration" className='linkliste' >Administration</Link></li>
                  <li className='li'><Link to="/contact" className='linkliste' >Contact</Link></li>
                  <li className='li'><Link to="/ToutesActualités" className='linkliste' >Actualités</Link></li>
                  <li className='li'><Link to="/" className='linkliste' >Recherche</Link></li>
                  <li className='li' style={{height:'1px',backgroundColor:'orange'}}><Link to="/" className='linkliste' ></Link></li>

                </ul>
              </div>
            </li>
            <li className="nav-item">
                  <input
                    type="checkbox"
                    id="departCheckbox"
                  />
                  <label htmlFor="departCheckbox" className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>Départements</label>
                  <div className='bar2 bar' id='bar2'>
                      <ul className='ul'>
                        <li className='li'><Link to="/departementInfo" className='linkliste' >Informatique</Link></li>
                        <li className='li'><Link to="/departementM" className='linkliste' >Mathématiques</Link></li>
                        <li className='li'><Link to="/departementT" className='linkliste' >Eléctronique</Link></li>                   
                        <li className='li' style={{height:'1px',backgroundColor:'orange'}}><Link to="/" className='linkliste' ></Link></li>

                      </ul>
                    </div>

                </li>
                <li className="nav-item">
                    <input
                      type="checkbox"
                      id="formationCheckbox"
                    />
                    <label htmlFor="formationCheckbox" className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>Formation</label>
                    <div className='bar3 bar' id='bar3'>
                        <ul className='ul'>                    
                          <li className='li'><Link to="/Ingenieurie" className='linkliste' >Cycle d'ingénieur</Link></li>
                        <li className='li'><Link to="/Prepa" className='linkliste' > Cycle préparatoire</Link></li>
                        <li className='li'><Link to="/Mastère" className='linkliste' >Mastère</Link></li>
                        <li className='li'><Link to="/licence" className='linkliste' >Licences</Link></li>    
                        <li className='li' style={{height:'1px',backgroundColor:'orange'}}><Link to="/" className='linkliste' ></Link></li>
                   
                      </ul>
                    </div>
              </li>
              <li className="nav-item logoitem">
                <Link to="/" className="logo" href="#">
                  <img src={logo} alt="logo isimm" style={{ width: '135px', height: 'auto', marginLeft: '10px' }} />
                </Link>
              </li>
  
            <li className="nav-item ">
              <input
                    type="checkbox"
                    id="etudianteCheckbox"
                  />
                  <label htmlFor="etudianteCheckbox" className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>Vie étudiante</label>
                  <div className='bar4 bar' id='bar4'>
                      <ul className='ul'>
                        <li className='li1'>
                        <input
                                type="checkbox"
                                id="assosCheckbox"
                              />
                              <label htmlFor="assosCheckbox" className={`nav-link label  ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>Vie associative <i class="fa-solid fa-caret-right"></i></label>
                              <div className='bar41 bar' id='bar41'>
                                  <ul className='ul'>
                                  <li className='li'><Link to="/Club" className='linkliste' >Clubs</Link></li>
                                  <li className='li'><Link to="/" className='linkliste' >Compititions </Link></li>
                                  <li className='li'><Link to="/Sport" className='linkliste' >Actualités Sportives</Link></li>
                                  <li className='li' style={{height:'1px',backgroundColor:'orange'}}><Link to="/" className='linkliste' ></Link></li>

                                  </ul>
                                </div>
                        </li>
                        <li className='li'><Link to="/Transport1" className='linkliste' >Vie Universitaire</Link></li>
                        <li className='li'><a href='http://www.biruni.tn/accueil.php' target='_blank' className='linkliste' >Bibliothèque</a></li>
                        <li className='li li6'><Link to="/Documents" className='linkliste' >Manuelle des procédures administratives</Link></li>
                        <li className='li' style={{height:'1px',backgroundColor:'orange'}}><Link to="/" className='linkliste' ></Link></li>

                      </ul>
                    </div>
              </li>
              <li className="nav-item ">
              <input
                    type="checkbox"
                    id="entrepriseCheckbox"
                  />
                  <label htmlFor="entrepriseCheckbox" className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>Entreprises</label>
                  <div className='bar5 bar' id='bar5'>
                      <ul className='ul'>
                        <li className='li'><Link to="/Formstage" className='linkliste' >Offre de stage</Link></li>
                        <li className='li'><Link to="/Formoffre" className='linkliste' >Offre d'emploi</Link></li>
                        <li className='li'><Link to="/" className='linkliste' >Annuaire des entreprises</Link></li>
                        <li className='li'><Link to="/" className='linkliste' >Calandrier des soutenances des PFE</Link></li> 
                        <li className='li' style={{height:'1px',backgroundColor:'orange'}}><Link to="/" className='linkliste' ></Link></li>                    
                       </ul>
                    </div>
              </li>
            <li className="nav-item">
              <Link to="/visitevirtuelle" className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`} >
                Visite virtuelle
              </Link>
            </li>
          
            <li className="nav-item">
              <Link to="/Acces"  className={`nav-link  ${isSecondNavbarScrolled ? 'scrolled' : ''}`} >
                <i className="fa-solid fa-user"></i>
              </Link>
            </li>          </ul>
          <div  onClick={handleClick}  className={`Toggle-bar   ${isSecondNavbarScrolled ? 'scrolled' : ''}`}>
            <i id="bar" className={clicked ? "fa-solid fa-xmark" : "fa-solid fa-bars"} ></i>
           
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;
